(function () {
  'use strict';

  var dialog = document.getElementById('region-popup');
  if (!dialog) return;

  var STORAGE_KEY = 'pd:region-confirmed';
  var COOKIE_KEY = 'pd_region_confirmed';
  var DETECT_TIMEOUT_MS = 1500;
  var LOADER_FAILSAFE_MS = 12000;

  var form = dialog.querySelector('form');
  var select = dialog.querySelector('select[name="country_code"]');
  var currentCode = (dialog.getAttribute('data-current-country') || '').toUpperCase();
  var submitting = false;
  var lastTrigger = null;

  /* storage */
  function readStored() {
    try {
      var value = window.localStorage.getItem(STORAGE_KEY);
      if (value) return value;
    } catch (e) {}
    var match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_KEY + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }
  function store(code) {
    try { window.localStorage.setItem(STORAGE_KEY, code); } catch (e) {}
    try {
      document.cookie = COOKIE_KEY + '=' + encodeURIComponent(code) + ';path=/;max-age=31536000;SameSite=Lax';
    } catch (e) {}
  }

  /* open / close */
  function openDialog() {
    if (dialog.open) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    document.documentElement.classList.add('region-popup-open');
  }
  function closeDialog() {
    if (typeof dialog.close === 'function') dialog.close();
    else { dialog.removeAttribute('open'); onClosed(); }
  }
  function onClosed() {
    document.documentElement.classList.remove('region-popup-open');
    if (!submitting) store(currentCode); // dismiss = "I'm fine here"
    if (lastTrigger && document.contains(lastTrigger)) {
      try { lastTrigger.focus({ preventScroll: true }); } catch (e) {}
    }
    lastTrigger = null;
  }

  dialog.addEventListener('close', onClosed);
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) closeDialog(); // backdrop click
  });

  form.addEventListener('submit', function (event) {
    if (select.value === currentCode) {
      event.preventDefault();
      store(currentCode);
      closeDialog();
      return;
    }
    submitting = true;
    store(select.value);
  });

  /* manual triggers (header, footer, mobile menu) */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-region-popup-open]');
    if (!trigger) return;
    event.preventDefault();

    var host = trigger.closest('[open]'); // close mobile drawer first (focus trap)
    if (host && typeof host.hide === 'function') host.hide();

    lastTrigger = trigger;
    select.value = currentCode;
    openDialog();
  });

  /* country detection */
  function availableCodes() {
    return Array.prototype.map.call(select.options, function (o) { return o.value.toUpperCase(); });
  }

  function detectCountry() {
    var codes = availableCodes();

    function fromLanguage() {
      var languages = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
      for (var i = 0; i < languages.length; i++) {
        var region = (languages[i] || '').split('-')[1];
        if (region && codes.indexOf(region.toUpperCase()) !== -1) return region.toUpperCase();
      }
      return null;
    }

    if (!window.fetch) return Promise.resolve(fromLanguage());

    var controller = window.AbortController ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, DETECT_TIMEOUT_MS) : null;
    var url = '/browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' +
      encodeURIComponent(currentCode) + '&language[enabled]=false';

    return fetch(url, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      signal: controller ? controller.signal : undefined
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return null;
        var candidates = [];
        if (data.detected_values && data.detected_values.country) candidates.push(data.detected_values.country.handle);
        (data.suggestions || []).forEach(function (s) {
          if (s && s.parts && s.parts.country) candidates.push(s.parts.country.handle);
        });
        for (var i = 0; i < candidates.length; i++) {
          var code = candidates[i] && String(candidates[i]).toUpperCase();
          if (code && codes.indexOf(code) !== -1) return code;
        }
        return null;
      })
      .catch(function () { return null; })
      .then(function (code) {
        if (timer) clearTimeout(timer);
        return code || fromLanguage();
      });
  }

  /* first visit logic */
  function whenLoaderGone(callback) {
    var loader = document.getElementById('pd-loader');
    if (!loader || !loader.parentNode) return callback();

    var done = false;
    function finish() {
      if (done) return;
      done = true;
      observer.disconnect();
      callback();
    }
    var observer = new MutationObserver(function () {
      if (!document.getElementById('pd-loader')) finish();
    });
    observer.observe(loader.parentNode, { childList: true });
    setTimeout(finish, LOADER_FAILSAFE_MS);
  }

  function shouldAutoOpen() {
    if (new URLSearchParams(window.location.search).has('region_popup')) return true;
    if (window.Shopify && window.Shopify.designMode) return false;
    if (navigator.webdriver || /bot|crawl|spider|slurp|lighthouse|headless/i.test(navigator.userAgent)) return false;
    return !readStored();
  }

  if (shouldAutoOpen()) {
    whenLoaderGone(function () {
      detectCountry().then(function (code) {
        if (code) select.value = code;
        openDialog();
      });
    });
  }
})();